module.exports = __webpack_public_path__ + "static/media/risk--en.c7453490.png";